import getCorUINav from './_coreUiNav';

export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Add a Site',
      //   to: '/add-a-site',
      //   icon: 'cil-plus',
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Sites',
        to: '/sites',
        icon: 'cil-site',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Plugins',
        to: '/plugins',
        icon: 'cil-plugin',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Themes',
        to: '/themes',
        icon: 'cil-theme',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Clients',
        to: '/clients',
        icon: 'cil-people',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Assets',
        to: '/assets',
        icon: 'cil-notes',
        beta: true,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Charges',
        to: '/charges',
        icon: 'cil-dollar',
        beta: true,
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'My Organisation',
      //   to: '/my-organisation',
      //   icon: 'cil-people'
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'My Account',
      //   to: '/my-account',
      //   icon: 'cil-people'
      // }
    ].concat(getCorUINav(false)),
  },
];
